import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from '../services/generic.service';
import { CidEnvService } from '../services/cid-env.service';
import { TranslateService } from '@ngx-translate/core';
import { TpmService } from '../services/tpm.service';

declare var require: any;

function bufferToBase64url(buffer: ArrayBuffer): string {
  const bytes = new Uint8Array(buffer);
  let str = '';
  for (const charCode of bytes) {
    str += String.fromCharCode(charCode);
  }
  const base64String = btoa(str);
  return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function base64urlToBuffer(base64url: string): ArrayBuffer {
  const padding = '='.repeat((4 - base64url.length % 4) % 4);
  const base64 = (base64url + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray.buffer;
}

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  appVersion = require('../../../package.json').version;

  @ViewChild('passwordField') passwordField!: ElementRef;

  constructor(private translate: TranslateService, private generic_service: GenericService, private toastr: ToastrService, private router: Router, private cid_service: CidEnvService, private tpmService: TpmService) { }

  emailOrPhone = '';
  isCid: any = false
  isNextbutton: any = false
  isPassword: any = false
  otp = '';
  password = '';
  userType = 'admin';
  roles: any = [];
  showPassword = "password";
  loginButton = false
  authenticationInput = false;
  cid: any
  isCompanySelected: boolean = false;
  rememberMe: boolean = false;

  companyList: any = []
  selectedCompany: any = [];

  ngOnInit(): void {
    this.isCid = false
    this.isNextbutton = true
    this.isPassword = false
    this.selectedCompany = [];
    this.isCompanySelected = false;
    this.companyList = []
    this.cid = 0
    // let hostname:any = window.location.hostname;
    // if(hostname != ''){
    //   this.cid = this.cid_service.getCid(hostname)
    // }
    const rememberedUser = localStorage.getItem('rememberedUser');
    const rememberedPassword = localStorage.getItem('rememberedPassword');
    const rememberedCid = localStorage.getItem('rememberedCid');

    if (rememberedUser) {
      this.emailOrPhone = rememberedUser;
      this.rememberMe = true;
      if (rememberedPassword) {
        this.password = rememberedPassword;
      }
      this.getUsersByPhNo(rememberedCid);
    }
    window.scrollTo(0, 0)

  }

  getUsersByPhNo(rememberedCid?: any): void {
    const value = this.emailOrPhone?.trim();

    if (!value) {
      this.toastr.error('Please fill mobile number');
      return;
    }

    // Reset state
    this.companyList = [];
    this.cid = 0;
    this.isPassword = false;
    this.isCid = false;

    this.generic_service.getUsersByPhNo(value).subscribe({
      next: ({ response }: any) => {
        const users = response ?? [];
        this.isNextbutton = false;

        if (users.length === 1) {
          this.cid = users[0]?.cid ?? 0;
          this.isCid = true;
          this.isPassword = true;
          this.companyList = [];
          if (users[0].authMode == 2) {
            this.authenticationInput = true;
          } else {
            this.authenticationInput = false;
          }
        } else if (users.length > 1) {
          this.companyList = users;
          let selectedUser = users[0];
          if (rememberedCid) {
            const foundUser = users.find((u: any) => u.cid == rememberedCid);
            if (foundUser) {
              selectedUser = foundUser;
            }
          }
          this.companySelect(selectedUser);
        } else {
          this.isPassword = true;
        }

        setTimeout(() => {
          if (this.passwordField) {
            this.passwordField.nativeElement.focus();
          }
        }, 100);

      },
      error: (err: any) => {
        console.error(err);
        this.toastr.error(
          err?.error?.errors?.[0]?.description || 'Something went wrong'
        );
      }
    });
  }



  login() {
    if (this.loginButton == true) {
      return;
    }
    this.loginButton = true;
    let body = {
      phone: this.emailOrPhone,
      cid: this.cid,
      password: this.password,
      otp: this.otp || null,

    }
    console.log(body)
    this.generic_service.adminLogin(body).subscribe(
      (response: any) => {
        const userCreds = response.response;
        this.completeLogin(userCreds);
      },
      async (err: any) => {
        const errorDescription = err?.error?.errors?.[0]?.description;
        if (errorDescription === "User Credentials are verified. Please proceed for secure login !!") {
          try {
            const loggedInUsername = this.emailOrPhone;
            // const optionsBody = { username: loggedInUsername };
            const optionsRes: any = await this.tpmService.loginOptions(this.emailOrPhone, this.cid).toPromise();

            let publicKeyCredentialRequestOptions = JSON.parse(optionsRes.response.optionsJson);
            publicKeyCredentialRequestOptions = publicKeyCredentialRequestOptions.publicKey || publicKeyCredentialRequestOptions;

            if (typeof publicKeyCredentialRequestOptions.challenge === 'string') {
              publicKeyCredentialRequestOptions.challenge = base64urlToBuffer(publicKeyCredentialRequestOptions.challenge);
            }

            if (publicKeyCredentialRequestOptions.allowCredentials) {
              for (let cred of publicKeyCredentialRequestOptions.allowCredentials) {
                if (typeof cred.id === 'string') {
                  cred.id = base64urlToBuffer(cred.id);
                }
              }
            }

            if (!navigator.credentials || !navigator.credentials.get) {
              throw new Error('Your browser does not support WebAuthn/TPM authentication.');
            }

            const credential: any = await navigator.credentials.get({
              publicKey: publicKeyCredentialRequestOptions
            });

            if (!credential) {
              throw new Error('TPM Authentication cancelled or failed.');
            }

            const credentialJson = JSON.stringify({
              id: credential.id,
              rawId: bufferToBase64url(credential.rawId),
              type: credential.type,
              response: {
                authenticatorData: bufferToBase64url(credential.response.authenticatorData),
                clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
                signature: bufferToBase64url(credential.response.signature),
                userHandle: credential.response.userHandle ? bufferToBase64url(credential.response.userHandle) : null
              }
            });

            const verifyBody = {
              username: loggedInUsername,
              cid: this.cid || 0,
              credentialJson: credentialJson
            };

            const verifyRes: any = await this.tpmService.loginVerify(verifyBody).toPromise();

            // TPM verification succeeded, complete login using the response from verify
            this.completeLogin(verifyRes.response);

          } catch (tpmErr: any) {
            console.error(tpmErr);
            this.loginButton = false;
            this.toastr.error(tpmErr.message || 'TPM Authentication failed');
          }
        } else {
          this.loginButton = false;
          console.log(err);
          this.toastr.error(errorDescription || 'Login failed');
        }
      }
    )
  }

  completeLogin(userCreds: any) {
    sessionStorage.setItem('userCreds', JSON.stringify(userCreds))
    sessionStorage.setItem('token', userCreds.token)
    sessionStorage.setItem('userEmail', userCreds.userEmail)
    sessionStorage.setItem('userMobileNo', userCreds.userMobileNo)
    sessionStorage.setItem('userName', userCreds.userName)
    sessionStorage.setItem('userType', userCreds.userType)
    sessionStorage.setItem('imageURL', userCreds.imageURL)
    sessionStorage.setItem('userId', userCreds.userId)
    sessionStorage.setItem('cid', userCreds.cid)

    if (this.rememberMe) {
      localStorage.setItem('rememberedUser', this.emailOrPhone);
      localStorage.setItem('rememberedPassword', this.password);
      localStorage.setItem('rememberedCid', this.cid);
    } else {
      localStorage.removeItem('rememberedUser');
      localStorage.removeItem('rememberedPassword');
      localStorage.removeItem('rememberedCid');
    }

    let language: any = userCreds.preferences?.localization?.language || 'en'
    localStorage.setItem('appLang', language);

    this.translate.setDefaultLang(language);
    this.translate.use(language);
    this.loginButton = false;

    const userType = (userCreds?.userType || '').trim().toUpperCase().replace(/-/g, '_');

    switch (userType) {
      case 'KIOSK_ADMIN':
      case 'RESTAURANT':
        window.location.href = '/restaurant';
        break;
      case 'KIOSK_ORDER_USER':
      case 'KIOSK':
        window.location.href = '/kiosk';
        break;
      case 'KIOSK_KITCHEN_USER':
      case 'KITCHEN':
        window.location.href = '/kitchen';
        break;
      case 'KIOSK_CUSTOMER_DISPLAY_USER':
      case 'CUSTOMER_DISPLAY':
        window.location.href = '/customer-display';
        break;
      default:
        window.location.href = '/admin';
        break;
    }
  }

  removeCompany() {
    this.companyList.forEach(
      (company: any) => {
        company.isSelected = false
        company.isDisplay = true
      }
    );

    this.selectedCompany = []
    this.isCompanySelected = false
    this.isPassword = false
    this.authenticationInput = false;
  }

  companySelect(company: any) {
    console.log(company)
    this.cid = company.cid;
    this.companyList.forEach(
      (company: any) => {
        company.isSelected = false
        company.isDisplay = false
      }
    );
    if (company.authMode == 2) {
      this.authenticationInput = true;
    } else {
      this.authenticationInput = false;
    }
    company.isSelected = true;
    company.isDisplay = true;
    this.selectedCompany = []
    this.selectedCompany.push(company)
    this.isCompanySelected = true
    console.log(this.selectedCompany)
    this.isCid = true
    this.isPassword = true
  }

  getAllRoles() {
    this.generic_service.getAllRoles().subscribe(
      (response: any) => {
        this.roles = response.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  togglePasswordIcon() {
    this.showPassword = this.showPassword === 'password' ? 'text' : 'password';
  }

  goToForgotPassword() {
    sessionStorage.removeItem('userCreds')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userEmail')
    sessionStorage.removeItem('userMobileNo')
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('userType')
    sessionStorage.removeItem('imageURL')
    sessionStorage.removeItem('userId')
    sessionStorage.removeItem('cid')
    sessionStorage.setItem('cid', this.cid)
    this.router.navigateByUrl('/forgot-password')
  }

}
